import { ChartDataAdapter } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/Summary/Visualizations/adapters/types';
import {
  BarChartData,
  CategoryValue
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/Summary/Visualizations/types';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { GetVariationsPageSizeResponse } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentServerProxy/types';

export class VariationsPageSizeAdapter implements ChartDataAdapter<BarChartData> {
  private pageSizeRecords: GetVariationsPageSizeResponse;

  constructor(pageSizeRecords: GetVariationsPageSizeResponse) {
    this.pageSizeRecords = pageSizeRecords;
  }

  transform(): BarChartData {
    const pageSizeRecords = this.pageSizeRecords.data.records || [];

    let chartRecords: CategoryValue[] = [];
    let categories: { id: number; name: string }[] = [];

    chartRecords = pageSizeRecords.map((item) => [item.parentSku, item.pageSize || 0]);
    categories = pageSizeRecords.map((item, idx) => ({ id: idx, name: item.parentSku }));

    return {
      chartData: [
        {
          type: 'column',
          data: chartRecords,
          metricType: METRICTYPE.VOLUME,
          categories
        }
      ]
    };
  }
}
